import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

/** *SENTRY INITIALIZATION------------------------------------------------------- */
import * as Sentry from '@sentry/angular';
import { Integrations } from '@sentry/tracing';

/** *GLOBAL COMPONENTS----------------------------------------------------------- */
import { MatIconRegistry } from '@angular/material/icon';

/** *SENTRY CONFIGURATION---------------------------------------------------------------*/
Sentry.init({
	dsn: 'https://0fa2f497fca84f649148e2265d8d4785@sentry.io/1539961',
	// This sets the sample rate to be 10%. You may want this to be sample at this rate in production
	replaysSessionSampleRate: 0.1,

	// If the entire session is not sampled, use the below sample rate to sample
	// sessions when an error occurs.
	replaysOnErrorSampleRate: 1.0,
	environment: environment.production ? 'production' : 'development',
	integrations: [
		new Sentry.Replay({
			// Additional SDK configuration goes in here, for example:
			maskAllText: false,
			maskAllInputs: true,
			blockAllMedia: false,
		}),
		new Integrations.BrowserTracing({
			tracingOrigins: [
				'https://whydonate.in/',
				'https://whydonate.com/',
			],
		}),
		
	],
	tracesSampleRate: 1.0,
	ignoreErrors: [
		'Non-Error exception captured',
		"Couldn't load script",
		"Failed to read the 'localStorage' property from 'Window'",
		'No error message',
		'Blocked a frame with origin',
		'The operation is insecure',
		'ResizeObserver loop completed',
		"reading 'getItem'",
		"evaluating 'localStorage.getItem'",
		"evaluating 'a.j'",
		"null (reading '_rawValidators')",
		"(reading 'operator_privacy')",
		'Loading chunk',
		'Large Render Blocking Asset',
		"Cannot read property 'getItem' of null",
		"(reading 'hasOwnProperty')",
		"(reading 'nativeElement')",
		"(reading '_avast_submit')",
		"'_rawValidators' of null",
		"reading 'transformed'",
		"reading 'L'",
		"(evaluating 'a.L')",
		"undefined is not an object (evaluating 'C.endsWith')",
		'Illegal invocation',
		'CanvasRenderingContext2D',
		'Object Not Found Matching Id:2',
		'this.loadedImage.transformed',
		'NG02100',
		'Uncaught (in promise): Event: {"isTrusted":true}',
		'Large Render Blocking Asset',
		'NetworkError when attempting to fetch resource.',
		'Cannot read properties of undefined',
		'Cannot read property "transformed" of null',
		'translateNotifyError is not a function',
		'withScope',
		'Can\'t find variable: disableWebkitEnterFullscreen',
	],
	//All these errors are explained inside a 'Sentry Errors' thread in dev channel.
	debug: false,
	attachStacktrace: true,
	release: "whydonate-web-portal@0.0.0", // Version for unminification
});
/**  *END OF SENTRY CONFIGURATION---------------------------------------------------------------*/

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
	constructor() {}

	handleError(error: any) {
		const chunkFailedMessage = /Loading chunk [\d]+ failed/;
		if (
			chunkFailedMessage.test(error.message) ||
			chunkFailedMessage.test(error.error) ||
			chunkFailedMessage.test(error) ||
			chunkFailedMessage.test(error.originalError)
		) {
			//window.location.reload();
		} else {
			Sentry.captureException(
				error.originalError || error || error.error || error.message
			);
			throw error;
		}
	}
}

/** *END OF SENTRY ------------------------------------------------------------- */

export class AppModule {
	constructor(iconRegistry: MatIconRegistry) {
		iconRegistry.setDefaultFontSetClass('material-icons-outlined');
	}
}
